/**
 * 再資源化
 * 再資源化処分場処理方法
 */
import Vue from "vue";
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/recycle_disposer_disposal_methods`;

const search_recycle_disposer_disposal_method = {
  namespaced: true,
  actions: {
    /**
     *
     * @param param0
     * @param param0.commit
     * @param param1
     * @param param1.item_id { Number } JWNET取扱品目ID
     * @param param1.disposer_id { Number } 処分事業者ID
     * @param param1.disposer_location_code { String } 処分事業場コード
     * @param param1.final_disposal { Boolean } 最終処分のみ
     * @return {Promise<unknown>}
     */
    index ({ commit }, { item_id, disposer_id, disposer_location_code, final_disposal }) {
      const params = {
        item_id: item_id,
        disposer_id: disposer_id,
        disposer_location_code: disposer_location_code,
        final_disposal: final_disposal,
      }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
};
export default search_recycle_disposer_disposal_method;
